/* ==========================================================================
   STICK'IT — SKIN « DIE-CUT STUDIO » : interactions additives.
   Chargé APRÈS stickit.js. Ne remplace, n'appelle ni ne patche aucune
   fonction de stickit.js ; n'écrit dans aucun élément du contrat DOM sauf
   le contenu visuel des éléments marqués [data-sk-glyph].
   API : window.StickitSkin = { glyph(el), refresh() }  — doc : 11-skin-system.md
   ========================================================================== */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };
  root.classList.add('sk-js');

  // dossier du skin, déduit de l'URL du script (fonctionne à toute profondeur)
  var BASE = (function () {
    var s = doc.currentScript && doc.currentScript.src;
    return s ? s.replace(/skin\.js(\?.*)?$/, '') : 'assets/skin/';
  })();

  /* 1. Brouillage de texte (initScramble) neutralisé : il réécrit textContent
     et détruit le compteur <span class="n"> des chips. On arrête le mouseenter
     en phase de capture, avant qu'il n'atteigne l'écouteur posé sur la cible. */
  window.addEventListener('mouseenter', function (ev) {
    var t = ev.target;
    // seul .chip est protégé (son compteur) ; le menu et les liens « .more » gardent l'effet au survol
    if (t && t.matches && t.matches('.chip')) ev.stopPropagation();
  }, true);

  /* 2. Chiffres en glyphes One Number (police du produit numéro de course).
     Le texte d'origine reste lisible par les lecteurs d'écran (.sk-sr). */
  var AR = [1.432, .78, 1.263, 1.508, 1.347, 1.254, 1.5, 1.41, 1.496, 1.504];
  function glyph(el) {
    if (!el || el.getAttribute('data-sk-glyphed')) return;
    var txt = (el.textContent || '').trim();
    if (!/\d/.test(txt)) return;
    var sr = doc.createElement('span'); sr.className = 'sk-sr'; sr.textContent = txt;
    var vis = doc.createElement('span'); vis.className = 'sk-gl'; vis.setAttribute('aria-hidden', 'true');
    txt.split('').forEach(function (c) {
      var n;
      if (/\d/.test(c)) {
        n = doc.createElement('i'); n.className = 'sk-d';
        n.style.setProperty('--m', 'url("' + BASE + 'img-digits-' + c + '.svg")');
        n.style.setProperty('--ar', AR[+c]);
      } else {
        n = doc.createElement('span'); n.className = c === ' ' ? 'sk-gs' : 'sk-gt'; n.textContent = c === ' ' ? '' : c;
      }
      vis.appendChild(n);
    });
    el.textContent = '';
    el.appendChild(sr); el.appendChild(vis);
    el.setAttribute('data-sk-glyphed', '1');
  }

  /* 3. Apparition : [data-sk-in] reçoit .sk-in à l'entrée dans l'écran
     (indépendant de .reveal/initReveal). Sur écran tactile, les étapes
     « sticker qui se décolle » se décollent seules en défilant. */
  function inview() {
    var els = $$('[data-sk-in]');
    var touch = !window.matchMedia('(hover:hover)').matches;
    var steps = touch ? $$('.step .peel').map(function (p) { return p.closest('.step'); }) : [];
    // tactile : les autocollants restent collés ; on les décolle d'un toucher (comme le survol sur ordinateur).
    // Le toucher est traité au touchend avec preventDefault : sinon le téléphone émule un survol (:hover collant,
    // et sur iPhone le 1er toucher ne fait QUE survoler) → sticker envolé mais texte caché, état désynchronisé.
    steps.forEach(function (s) {
      var x0 = 0, y0 = 0, moved = false, lastTouch = 0;
      s.addEventListener('touchstart', function (e) {
        var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; moved = false;
      }, { passive: true });
      s.addEventListener('touchmove', function (e) {
        var t = e.touches[0];
        if (Math.abs(t.clientX - x0) > 10 || Math.abs(t.clientY - y0) > 10) moved = true;
      }, { passive: true });
      s.addEventListener('touchend', function (e) {
        if (moved || e.touches.length) return;
        e.preventDefault();
        lastTouch = Date.now();
        s.classList.toggle('sk-peeled');
      });
      s.addEventListener('click', function () {
        if (Date.now() - lastTouch < 800) return;
        s.classList.toggle('sk-peeled');
      });
    });
    if (!('IntersectionObserver' in window) || reduced) {
      els.forEach(function (e) { e.classList.add('sk-in'); });
      return;
    }
    var io = new IntersectionObserver(function (ent) {
      ent.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        el.classList.add('sk-in');
        io.unobserve(el);
      });
    }, { threshold: 0.35, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* 4. Héros : progression du scroll (--sk-p 0→1) + lumière studio qui suit
     le pointeur sur la coque (--sk-mx/--sk-my). Transform/opacity uniquement. */
  function hero() {
    var h = doc.querySelector('[data-sk-hero]');
    if (!h) return;
    var v = h.querySelector('video');
    if (v) {
      if (reduced) { v.pause(); v.removeAttribute('autoplay'); }
      else if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) {
          var p = e[0].isIntersecting ? v.play() : v.pause();
          if (p && p.catch) p.catch(function () {});
        }, { threshold: 0.05 }).observe(h);
      }
    }
    if (reduced) return;
    var ticking = false;
    function run() {
      var r = h.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, -r.top / Math.max(1, r.height)));
      h.style.setProperty('--sk-p', p.toFixed(3));
      ticking = false;
    }
    addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
    if (fine) {
      h.addEventListener('pointermove', function (ev) {
        var r = h.getBoundingClientRect();
        h.style.setProperty('--sk-mx', ((ev.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        h.style.setProperty('--sk-my', ((ev.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      });
    }
  }

  /* 5. Panier : rebond de la pastille quand le compteur change (observe le
     texte écrit par Cart.render, sans y toucher). */
  function bagBump() {
    $$('.bag .count').forEach(function (c) {
      var last = c.textContent;
      new MutationObserver(function () {
        if (c.textContent === last) return;
        var up = parseInt(c.textContent.replace(/\D/g, ''), 10) > parseInt(last.replace(/\D/g, ''), 10);
        last = c.textContent;
        var bag = c.closest('.bag');
        if (!up || reduced || !bag) return;
        bag.classList.remove('sk-bump'); void bag.offsetWidth; bag.classList.add('sk-bump');
      }).observe(c, { childList: true, characterData: true, subtree: true });
    });
  }

  /* 6. Filet de sécurité : les entrées animées du héros attendent body.loaded
     (posé par initPreloader). Si ce signal manque, on le pose nous-mêmes. */
  function loadedFallback() {
    setTimeout(function () { if (!doc.body.classList.contains('loaded')) doc.body.classList.add('loaded'); }, 4500);
  }

  /* 7. Logo animé (ANIM/hf_…0ffa1db8, accéléré) dans les phases de chargement.
     - 1re visite : la vidéo complète (~2,3 s) dans #preloader ; le préchargeur reste
       affiché (.sk-hold) jusqu'à la fin de la vidéo, au plus 3,2 s.
     - Changement de page : version éclair (0,53 s) pendant le voile #wipe.out,
       puis l'image du logo chromé pendant le retrait du voile (#wipe.in).
     On n'ajoute que des éléments visuels : #preloader, #wipe et leurs classes
     restent pilotés par stickit.js. */
  function mkVideo(name, cls) {
    var v = doc.createElement('video');
    v.className = cls; v.muted = true; v.defaultMuted = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
    v.preload = 'auto';
    ['mp4', 'webm'].forEach(function (ext) {
      // type MIME « video/mp4 » (la conversion Shopify avait transformé « video/ » en « video- » : sources ignorées)
      var s = doc.createElement('source'); s.src = BASE + 'video-' + name + '.' + ext; s.type = 'video/' + ext; v.appendChild(s);
    });
    return v;
  }
  function logoAnim() {
    if (reduced) return;
    var pre = doc.getElementById('preloader');
    if (pre && pre.isConnected) {
      var box = pre.querySelector('.pre-in') || pre;
      var v = mkVideo('logo-intro', 'sk-pre-vid');
      box.insertBefore(v, box.firstChild);
      pre.classList.add('sk-has-vid', 'sk-hold');
      var release = function () { pre.classList.remove('sk-hold'); };
      v.addEventListener('ended', release);
      v.addEventListener('error', release, true);
      setTimeout(release, 3200);
      var p = v.play(); if (p && p.catch) p.catch(release);
    }
    var w = doc.getElementById('wipe');
    if (w) {
      var img = w.querySelector('img');
      if (img) img.src = BASE + 'img-logo-chrome.webp';
      var wv = mkVideo('logo-wipe', 'sk-wipe-vid');
      w.appendChild(wv);
      new MutationObserver(function () {
        if (!w.classList.contains('out')) return;
        try { wv.currentTime = 0; } catch (e) {}
        var q = wv.play(); if (q && q.catch) q.catch(function () {});
      }).observe(w, { attributes: true, attributeFilter: ['class'] });
    }
  }

  /* 8. Menu : à l'arrivée sur chaque page, les liens se « décodent » — lettres
     aléatoires qui défilent puis se figent de gauche à droite (même jeu de
     caractères que le survol de stickit.js). Texte final = texte d'origine. */
  /* Largeur figée des liens : le texte aléatoire (décodage + survol de stickit.js)
     n'a pas la largeur du vrai texte ; sans ça la barre se redimensionne et
     écrase le logo. On mesure le texte d'origine dans un clone invisible. */
  function lockNav() {
    var links = $$('.nav-links a');
    if (!links.length) return;
    links.forEach(function (el) {
      if (!el.dataset.skOrig) el.dataset.skOrig = el.textContent;
      // mesure synchrone du lien lui-même avec son vrai texte (aucun rendu entre-temps)
      var cur = el.textContent;
      el.style.width = ''; el.style.whiteSpace = 'nowrap';
      el.textContent = el.dataset.skOrig;
      var w = el.getBoundingClientRect().width;
      el.textContent = cur;
      el.style.display = 'inline-block'; el.style.overflow = 'hidden'; el.style.boxSizing = 'border-box';
      el.style.width = Math.ceil(w) + 'px';
    });
  }
  function navDecode() {
    lockNav();
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(lockNav);
    var rt; addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(lockNav, 150); });
    if (reduced) return;
    var CH = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789/\\#@$%&*';
    $$('.nav-links a').forEach(function (el, n) {
      var orig = el.dataset.skOrig || el.textContent;
      if (!orig.trim() || el.children.length) return;
      var i = -n * 2.2;                 // décalage : les liens se décodent en cascade
      var id = setInterval(function () {
        el.textContent = orig.split('').map(function (c, k) {
          if (c === ' ' || k < i) return c;
          return CH[Math.floor(Math.random() * CH.length)];
        }).join('');
        i += 0.6;
        if (i >= orig.length) { clearInterval(id); el.textContent = orig; }
      }, 30);
    });
  }

  /* 10. Bande « Sorties d'atelier » : défilement automatique + glisser à la souris / au doigt
     avec élan. Le contenu est doublé dans le HTML (boucle sans fin) : on boucle sur la moitié.
     Remplace l'animation CSS « slide » quand le JS est actif. */
  function stripDrag() {
    // « Sorties d'atelier » : galerie en mosaïque plein cadre (remplace la bande défilante).
    // Les 12 réalisations (la bande les contient en double) deviennent des tuiles avec légende tirée du texte alternatif.
    var strip0 = doc.querySelector('.sk-strip');
    if (strip0 && !doc.querySelector('.sk-curve')) {
      var seen = {}, items = [];
      $$('figure img', strip0).forEach(function (im) {
        var src = im.getAttribute('src'); if (seen[src]) return; seen[src] = 1;
        var alt = im.getAttribute('alt') || '', h = (alt.match(/@[\w.]+/) || [''])[0].replace(/\.$/, '');
        var what = alt.replace(/\s*[—–-]\s*réalisation Stick'it\s*$/i, '').replace(/\s*(de|du|,)?\s*@[\w.]+.*$/, '').replace(/\s*,?\s*photo\s*$/i, '').trim();
        items.push({ src: src, alt: alt, h: h, what: what, w: +im.getAttribute('width') || 900, ht: +im.getAttribute('height') || 1200 });
      });
      // Rangée courbe : les photos défilent de droite à gauche à l'intérieur d'un cylindre.
      // Le centre est à plat, les bords se courbent vers soi et s'effacent dans la page.
      // Une boîte CSS ne se plie pas : chaque tuile est découpée en SLICES bandes verticales, chacune
      // tournée de quelques degrés autour de l'axe du cylindre ; la tuile entière (preserve-3d) suit
      // l'arc par une seule animation rotateY, donc ses bandes ne se décalent jamais.
      // Une tuile reçoit la photo suivante à chaque tour, hors écran. Clic / toucher = visionneuse.
      var sec = doc.createElement('div'); sec.className = 'sk-curve-sec';
      var hero = doc.createElement('div'); hero.className = 'sk-curve';
      hero.tabIndex = 0; hero.setAttribute('role', 'button'); hero.setAttribute('aria-label', 'Agrandir les photos de réalisations');
      var band = doc.createElement('div'); band.className = 'sk-curve-band'; band.setAttribute('aria-hidden', 'true');
      var cssEl = doc.createElement('style');
      hero.appendChild(cssEl); hero.appendChild(band); sec.appendChild(hero);
      strip0.parentNode.insertBefore(sec, strip0);
      strip0.parentNode.removeChild(strip0);

      var SLICES = 16, CAM = 1.6, MAXW = 38, ASPECT = 4 / 5, TILE = 60, GAP = 7, AXIS = 50, SPEED = 4.2;
      var BEND = 72 * Math.PI / 180;
      var arcK = (CAM - 1 + Math.cos(BEND)) / (2 * CAM * Math.sin(BEND));   // rayon / largeur
      var rPct = 100 * arcK, radius = rPct.toFixed(3) + 'cqw';
      var r4 = function (n) { return +n.toFixed(4); };
      var u = function (n) { return 'calc(' + r4(n) + ' * min(' + TILE + 'cqh, ' + r4(MAXW / ASPECT) + 'cqw))'; };
      var turn = function (d) { return 'translateZ(' + radius + ') rotateY(' + r4(d) + 'deg) translateZ(-' + radius + ')'; };
      band.style.perspective = (rPct * CAM).toFixed(3) + 'cqw';
      band.style.perspectiveOrigin = '50% ' + AXIS + '%';

      var measureCurve = function (w, h) {
        var th = Math.min(TILE / 100 * h, MAXW / 100 * w / ASPECT), rad = w * arcK;
        if (!(th > 0) || !(rad > 0)) return null;
        var deg = function (x) { return x * 180 / Math.PI; };
        var unit = deg(th / rad), pitch = (ASPECT + GAP / 100) * unit, limit = deg(BEND) + ASPECT * unit / 2;
        var cols = Math.min(40, Math.max(2, Math.ceil(2 * limit / pitch)));
        var sweep = r4(cols * pitch / 2);
        return { cols: cols, sweep: sweep, unit: r4(unit), limit: r4(Math.min(sweep, limit)) };
      };
      // les photos ne sont chargées qu'à l'approche de la section (pas de poids en plus en haut de page)
      var live = !('IntersectionObserver' in window);
      var paint = function (tile) {
        var src = items[tile._i].src;
        if (!live || tile._src === src) return;
        tile._src = src;
        $$('img', tile).forEach(function (im) { im.src = src; });
      };
      var setTileImg = function (tile, idx) { tile._i = ((idx % items.length) + items.length) % items.length; paint(tile); };
      var curL = null;
      var build = function (L) {
        curL = L; band.textContent = '';
        var hide = r4((L.sweep - L.limit) / (2 * L.sweep || 1) * 100), dur = L.cols * SPEED, share = ASPECT / SLICES;
        cssEl.textContent = '@keyframes skCurveOrbit{from{transform:' + turn(-L.sweep) + '}to{transform:' + turn(L.sweep) + '}' +
          '0%,' + hide + '%,' + (100 - hide) + '%,100%{visibility:hidden}' +
          (hide + 0.001) + '%,' + (100 - hide - 0.001) + '%{visibility:visible}}';
        for (var t = 0; t < L.cols; t++) {
          var tile = doc.createElement('div'); tile.className = 'sk-ct';
          var first = L.cols - 1 - t;   // ordre d'entrée à l'écran
          tile.style.cssText = 'left:calc(50% - ' + u(ASPECT / 2) + ');top:calc(' + AXIS + '% - ' + u(0.5) + ');width:' + u(ASPECT) +
            ';height:' + u(1) + ';animation:skCurveOrbit ' + dur + 's linear ' + (-t * SPEED) + 's infinite';
          for (var k = 0; k < SLICES; k++) {
            var s = doc.createElement('div'); s.className = 'sk-cs' + (k === 0 ? ' l' : k === SLICES - 1 ? ' r' : '');
            s.style.cssText = 'left:' + u((ASPECT - share) / 2) + ';width:' + (k === SLICES - 1 ? u(share) : 'calc(' + u(share) + ' + 1px)') +
              ';height:' + u(1) + ';transform:' + turn((ASPECT / 2 - (k + 0.5) * share) * L.unit);
            var im = doc.createElement('img'); im.alt = ''; im.draggable = false; im.decoding = 'async';
            im.style.cssText = 'left:' + u(-k * share) + ';width:' + u(ASPECT) + ';height:' + u(1);
            s.appendChild(im); tile.appendChild(s);
          }
          setTileImg(tile, first);
          (function (tile, first) {
            tile.addEventListener('animationiteration', function (e) {
              var lap = Math.round(e.elapsedTime / dur);
              setTileImg(tile, lap * L.cols + first);
            });
            tile.addEventListener('click', function () { openLb(tile._i || 0); });
          })(tile, first);
          band.appendChild(tile);
        }
        hero.classList.add('sk-ready');
      };
      var relayout = function () {
        var L = measureCurve(hero.clientWidth, hero.clientHeight);
        if (!L || (curL && curL.cols === L.cols && curL.sweep === L.sweep && curL.unit === L.unit)) return;
        build(L);
      };
      if ('ResizeObserver' in window) new ResizeObserver(relayout).observe(hero); else { relayout(); addEventListener('resize', relayout); }
      relayout();
      hero.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLb(0); } });
      // hors écran : animation en pause ; à l'approche, les 12 photos sont chargées d'avance
      if ('IntersectionObserver' in window) {
        hero.classList.add('sk-off');
        var loaded = false;
        new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            hero.classList.toggle('sk-off', !e.isIntersecting);
            if (e.isIntersecting && !loaded) {
              loaded = live = true;
              items.forEach(function (it) { new Image().src = it.src; });
              $$('.sk-ct', band).forEach(paint);
            }
          });
        }, { rootMargin: '300px 0px' }).observe(hero);
      }

      // visionneuse : photo entière, flèches / glisser pour naviguer, Échap ou clic sur le fond pour fermer
      var lb = doc.createElement('div'); lb.className = 'sk-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.hidden = true;
      lb.innerHTML = '<img class="sk-lb-img" alt=""><button class="sk-lb-x" type="button" aria-label="Fermer">&times;</button>' +
        '<button class="sk-lb-nav sk-lb-prev" type="button" aria-label="Photo précédente">&#8249;</button>' +
        '<button class="sk-lb-nav sk-lb-next" type="button" aria-label="Photo suivante">&#8250;</button><span class="sk-lb-n"></span>';
      doc.body.appendChild(lb);
      var lbImg = lb.querySelector('.sk-lb-img'), lbN = lb.querySelector('.sk-lb-n'), cur = 0, back = null;
      var show = function (i) {
        cur = (i + items.length) % items.length;
        lbImg.src = items[cur].src; lbImg.alt = items[cur].alt;
        lbN.textContent = (cur + 1) + ' / ' + items.length;
      };
      var openLb = function (i) {
        back = doc.activeElement; show(i); lb.hidden = false;
        root.classList.add('sk-lb-on');
        requestAnimationFrame(function () { lb.classList.add('open'); });
        lb.querySelector('.sk-lb-x').focus();
      };
      var closeLb = function () {
        lb.classList.remove('open'); root.classList.remove('sk-lb-on');
        setTimeout(function () { lb.hidden = true; }, 250);
        if (back && back.focus) back.focus();
      };
      lb.addEventListener('click', function (e) {
        if (e.target.closest('.sk-lb-prev')) show(cur - 1);
        else if (e.target.closest('.sk-lb-next')) show(cur + 1);
        else if (e.target === lb || e.target.closest('.sk-lb-x')) closeLb();
      });
      doc.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') closeLb();
        else if (e.key === 'ArrowLeft') show(cur - 1);
        else if (e.key === 'ArrowRight') show(cur + 1);
      });
      var sx = null;
      lb.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 45) show(cur + (dx < 0 ? 1 : -1));
      });
    }    $$('.sk-strip .strip-track').forEach(function (track) {
      var strip = track.parentElement;
      track.style.animation = 'none';
      strip.classList.add('sk-drag');
      $$('img', track).forEach(function (i) { i.draggable = false; });
      var dir = strip.getAttribute('data-dir') === '1' ? 1 : -1;
      var x = 0, v = reduced ? 0 : 0.45 * dir, auto = reduced ? 0 : 0.45 * dir, half = 0, down = false, lastX = 0, lastT = 0, moved = 0, hover = false;
      function measure() { half = track.scrollWidth / 2; }
      measure(); addEventListener('resize', measure);
      if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(measure);
      $$('img', track).forEach(function (i) { if (!i.complete) i.addEventListener('load', measure, { once: true }); });
      function wrap() { if (!half) return; while (x <= -half) x += half; while (x > 0) x -= half; }
      function tick() {
        // hors écran (.sk-off posé par l'observateur plus bas) : bande figée, aucun travail
        if (!down && strip.classList.contains('sk-off')) { requestAnimationFrame(tick); return; }
        if (!down) {
          v += ((hover ? auto * 0.25 : auto) - v) * 0.04;   // retour doux vers la vitesse de croisière
          x += v;
        }
        wrap();
        track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
      strip.addEventListener('pointerenter', function () { hover = true; });
      strip.addEventListener('pointerleave', function () { hover = false; });
      strip.addEventListener('pointerdown', function (e) {
        if (e.button !== undefined && e.button !== 0) return;
        down = true; moved = 0; lastX = e.clientX; lastT = performance.now(); v = 0;
        strip.classList.add('sk-grabbing');
        try { strip.setPointerCapture(e.pointerId); } catch (x2) {}
      });
      strip.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - lastX, now = performance.now();
        x += dx; moved += Math.abs(dx);
        v = dx / Math.max(1, now - lastT) * 16;   // vitesse en px/image pour l'élan
        lastX = e.clientX; lastT = now;
      });
      function up() { if (!down) return; down = false; strip.classList.remove('sk-grabbing'); v = Math.max(-26, Math.min(26, v)); }
      strip.addEventListener('pointerup', up);
      strip.addEventListener('pointercancel', up);
      // un glisser ne doit pas déclencher de clic sur un lien éventuel
      strip.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }

  function refresh() { $$('[data-sk-glyph]').forEach(glyph); }

  /* Titres découpés lettre à lettre (stickit.js initSplit) : l'espace entre les
     mots n'était qu'un ::before CSS, invisible pour Google et les lecteurs
     d'écran (« Troisétapes »). On met une vraie espace dans chaque .sp. */
  function splitSpaces() {
    $$('.split .sp').forEach(function (s) { if (!s.firstChild) s.textContent = ' '; });
  }

  /* FAQ : une seule question ouverte à la fois (ouvrir un onglet referme les autres) */
  function faqAccordion() {
    $$('.faq').forEach(function (faq) {
      faq.addEventListener('toggle', function (ev) {
        var d = ev.target;
        if (!d.open || d.tagName !== 'DETAILS') return;
        $$('details', faq).forEach(function (o) { if (o !== d && o.open) o.open = false; });
      }, true);                                       // « toggle » ne remonte pas : capture
    });
  }

  /* Retour en haut : pastille ronde (verre sombre), flèche, anneau rose qui suit la progression
     de la lecture ; apparaît après un peu de défilement, se décale au-dessus de la barre d'achat mobile. */
  function backToTop() {
    if (doc.querySelector('.sk-top')) return;
    var b = doc.createElement('button');
    b.type = 'button'; b.className = 'sk-top'; b.setAttribute('aria-label', 'Revenir en haut');
    b.innerHTML = '<svg viewBox="0 0 48 48" aria-hidden="true"><circle class="sk-top-track" cx="24" cy="24" r="21"/>' +
      '<circle class="sk-top-ring" cx="24" cy="24" r="21" pathLength="100"/><path class="sk-top-arrow" d="M24 31V17M17.5 23.5 24 17l6.5 6.5"/></svg>';
    doc.body.appendChild(b);
    var ring = b.querySelector('.sk-top-ring'), bar = doc.querySelector('.buybar'), ticking = false;
    function sync() {
      ticking = false;
      var max = Math.max(1, doc.documentElement.scrollHeight - innerHeight), y = scrollY;
      b.classList.toggle('on', y > Math.min(700, innerHeight * 0.9));
      ring.style.strokeDashoffset = String(100 - Math.min(100, (y / max) * 100));
      b.classList.toggle('sk-top-raise', !!(bar && bar.classList.contains('on')));
    }
    addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(sync); } }, { passive: true });
    addEventListener('resize', sync);
    b.addEventListener('click', function () {
      var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      var focus = doc.querySelector('.skip') || doc.body; try { focus.focus({ preventScroll: true }); } catch (e) {}
    });
    sync();
  }

  /* Titre néon « Shhhh.... » (accueil, Obsaners) : la lueur animée en text-shadow obligeait à redessiner
     le titre et ses flous de 180 px à chaque image. On la répartit sur deux copies (lueur repos / lueur pic)
     dont seule l'opacité varie (calques GPU) ; le texte passe dans une 3e couche au-dessus. Rendu identique. */
  function shhGlow() {
    if (reduced) return;
    $$('.sk-ob-shh-t').forEach(function (t) {
      if (t.classList.contains('sk-shh-lit')) return;
      var txt = t.textContent;
      t.textContent = '';
      // ordre d'origine : le texte balayé, puis la lueur qui se dessine par-dessus (elle teinte les lettres)
      var f = doc.createElement('span'); f.className = 'sk-shh-fill'; f.textContent = txt;
      t.appendChild(f);
      ['a', 'b'].forEach(function (k) {
        var g = doc.createElement('span');
        g.className = 'sk-shh-gl sk-shh-gl-' + k; g.setAttribute('aria-hidden', 'true'); g.textContent = txt;
        t.appendChild(g);
      });
      t.classList.add('sk-shh-lit');
    });
  }

  /* « Le principe » (accueil) : les 3 stickers recouvrent le texte de leur étape et prenaient sa hauteur
     (textes de longueurs différentes → stickers de tailles différentes). Les 3 textes reçoivent la hauteur
     du plus long ; recalcul au redimensionnement, au chargement des polices et après une traduction. */
  function equalPeels() {
    var ps = $$('.sk-concept .step .peel p');
    if (ps.length < 2) return;
    var t = null;
    function fit() {
      ps.forEach(function (p) { p.style.minHeight = ''; });
      var h = Math.max.apply(null, ps.map(function (p) { return p.offsetHeight; }));
      if (h > 0) ps.forEach(function (p) { p.style.minHeight = h + 'px'; });
    }
    function later() { clearTimeout(t); t = setTimeout(fit, 120); }
    fit();
    addEventListener('resize', later);
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(fit);
    ps.forEach(function (p) { new MutationObserver(later).observe(p, { childList: true, characterData: true, subtree: true }); });
  }

  function boot() {
    // modules isolés : une erreur dans l'un ne coupe plus les animations des suivants
    [shhGlow, equalPeels, faqAccordion, backToTop, splitSpaces, refresh, inview, hero,
     bagBump, stripDrag, navDecode, loadedFallback].forEach(function (fn) {
      try { fn(); } catch (e) { if (window.console) console.error('[skin] ' + fn.name, e); }
    });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* 9. Langues FR · EN · DE · IT (i18n.js : boutons de l'en-tête + traduction).
     Si une langue autre que le FR est mémorisée, la page reste masquée le temps
     de l'appliquer (i18n.js la ré-affiche ; filet de 1,5 s dans i18n.js).
     Première visite sans choix mémorisé : langue du navigateur (FR / EN / DE / IT / ES,
     sinon EN). Les robots gardent le FR pour que Google indexe la version source. */
  (function () {
    var l; try { l = localStorage.getItem('stickit_lang_v1'); } catch (e) {}
    if (!l && !/bot|crawl|spider|slurp|lighthouse|headless|facebookexternalhit|preview/i.test(navigator.userAgent || '')) {
      var prefs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || 'fr'];
      for (var i = 0; i < prefs.length && !l; i++) {
        var p = String(prefs[i]).slice(0, 2).toLowerCase();
        if (/^(fr|en|de|it|es)$/.test(p)) l = p;
      }
      l = l || 'en';
      try { localStorage.setItem('stickit_lang_v1', l); } catch (e) {}
    }
    if (l && l !== 'fr') root.style.visibility = 'hidden';
    var s = doc.createElement('script');
    s.src = (window.SK_I18N && window.SK_I18N.js) || BASE + 'i18n.js';
    s.onerror = function () { root.style.visibility = ''; };
    (doc.head || root).appendChild(s);
  })();

  /* 16. Accessibilité : nom accessible pour le champ de texte de l'outil casque (attribut seul, comportement inchangé) */
  $$('[data-hc-input]').forEach(function (i) { if (!i.getAttribute('aria-label')) i.setAttribute('aria-label', 'Ton texte pour le casque'); });

  /* 15. Avis clients : affichage (accueil) et formulaire (contact) */
  if (doc.querySelector('.sk-revs, #avis')) {
    var rs = doc.createElement('script'); rs.src = BASE + 'reviews.js'; rs.defer = true;
    (doc.head || root).appendChild(rs);
  }

  /* 14. Vidéos de fond [data-bg-video] : vitesse normale (stickit.js les ralentissait à 40 %) */
  $$('video[data-bg-video]').forEach(function (v) {
    var normal = function () { if (v.playbackRate !== 1) v.playbackRate = 1; };
    v.defaultPlaybackRate = 1; normal();
    v.addEventListener('loadedmetadata', normal); v.addEventListener('play', normal); v.addEventListener('ratechange', normal);
  });

  /* 13. Fluidité : les sections à animations en boucle sont mises en pause hors écran */
  if ('IntersectionObserver' in window) {
    var offIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) { e.target.classList.toggle('sk-off', !e.isIntersecting); });
    }, { rootMargin: '150px 0px' });
    $$('.sk-hero, .obs, .marquee, .sk-strip, .sk-concept, .site-foot, .strate-band').forEach(function (s) { offIO.observe(s); });
    // vidéos de décor (lecture auto + [data-sk-lazyplay]) : lecture à l'écran, pause hors écran.
    // Si le navigateur a refusé la lecture automatique (téléphone, économie d'énergie), on retente
    // à chaque retour à l'écran, au premier toucher et au retour arrière (page restaurée).
    var playV = function (v) {
      if (reduced || !v.paused) return;
      if (v.hasAttribute('data-sk-lazyplay') && v.preload === 'none') { v.preload = 'auto'; v.load(); }
      v.muted = true;                                   // condition de la lecture auto sur iOS
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    };
    var vids = $$('video[autoplay], video[data-sk-lazyplay]');
    var vidIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target; v._skVis = e.isIntersecting;
        if (!e.isIntersecting) { if (!v.paused) v.pause(); }
        else playV(v);
      });
    }, { rootMargin: '100px 0px' });
    vids.forEach(function (v) { vidIO.observe(v); });
    var retry = function () { vids.forEach(function (v) { if (v._skVis) playV(v); }); };
    ['touchstart', 'pointerdown'].forEach(function (t) { addEventListener(t, retry, { once: true, passive: true }); });
    addEventListener('pageshow', function (ev) { if (ev.persisted) retry(); });
  }

  /* 12. Curseur « die-cut » (cursor.js) — souris uniquement */
  if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var cs = doc.createElement('script'); cs.src = BASE + 'cursor.js'; cs.defer = true;
    (doc.head || root).appendChild(cs);
  }

  window.StickitSkin = { glyph: glyph, refresh: refresh, base: BASE };
})();
